/**
 * The name to show for the signed-in person — top bar, user menu.
 *
 * 🔴 DSH-026. The top bar rendered `user.full_name ?? 'User'`, and /auth/me
 * never sent full_name, so every account read "User" and the menu's name line
 * was blank. The server sends it now; this still builds it from first and last
 * name when it is absent, because the user object in a browser's storage was
 * saved by the old server and is read before /auth/me answers. Last of all the
 * email, which every account has — never the word "User".
 */
interface NamedAccount {
  full_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

export function accountName(user: NamedAccount | null | undefined): string {
  if (!user) return '';
  const full = (user.full_name ?? '').trim();
  if (full) return full;
  const parts = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
  return parts || (user.email ?? '');
}
